import { useEffect, useState } from 'react';
import { LineLayer } from '@deck.gl/layers';

const Assignments = ({ assignments }) => {
  const [lines, setLines] = useState([]);
  useEffect(() => {
    
    const newLines = [];

      for (let i = 0; i < assignments.length; i++) {

        const line = {
          sourcePosition: [assignments[i][0].lng, assignments[i][0].lat],
          targetPosition: [assignments[i][1].lng, assignments[i][1].lat]
        };

        newLines.push(line);
      
    }
    // Update the state with the new lines
    setLines(newLines);
  }, [assignments]);

  const layer = new LineLayer({
    id: 'LineLayer',
    data: lines,
    getColor: [0,0,0],
    getWidth: 4,
    pickable: true
  });

  return layer;
};

export default Assignments;